const clientConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  dbUrl: "https://morasha-db.activebranding.co.il",
  backendUrl: "https://morasha.co.il",
  // backendUrl: "http://localhost:8000",
  
  siteLang: "he",
  primaryColor: "#124b78",
  primaryColorHover: "#0f3d64",
  secondaryColor: "#37ACBB",
  secondaryColorHover: "#2f94a5",
  lightBrownColor: "#BB9D80",
  darkBrownColor: "#5A3622",
};
export default clientConfig;
